import { Button, List, Modal } from '@mairistem/composants';
import React from 'react';
import type ImputationNonTrouvee from '../../../interfaces/simulation/imputationNonTrouvee';
import type ServiceNonHabilite from '../../../interfaces/simulation/serviceNonHabilite';
import {
	getLibelleImputationNonTrouvee,
	getLibelleServiceNonHabilite,
	getResumeImputationsNonTrouvees,
	getResumeServicesNonHabilites,
} from '../../../utils/simulation/rapportImputationsNonTrouvees';
import RapportJob from './RapportJob';

interface RapportImputationsNonTrouveesProps {
	anneeExercice?: number;
	imputations: ImputationNonTrouvee[];
	onClose: () => void;
	// Restes a realiser repris sur "Aucun service" (reprise des RAR seulement)
	servicesNonHabilites?: ServiceNonHabilite[];
	// Debut du resume, par exemple "Import effectué."
	traitement: string;
}

/**
 * Contenu de modal listant les lignes APCP ignorees par un traitement long et,
 * pour la reprise des RAR, les restes a realiser repris sur "Aucun service"
 */
const RapportImputationsNonTrouvees = ({
	anneeExercice,
	imputations,
	onClose,
	servicesNonHabilites = [],
	traitement,
}: RapportImputationsNonTrouveesProps) => (
	<>
		<Modal.Content>
			<RapportJob
				resume={getResumeImputationsNonTrouvees(
					imputations,
					traitement,
					anneeExercice,
				)}
				testIdResume="resumeImputationsNonTrouvees"
				titreDetail="Détail des lignes non importées"
			>
				{imputations.length > 0 && (
					<List
						bulleted
						items={imputations.map((imputation, index) => ({
							content: getLibelleImputationNonTrouvee(imputation),
							// Une meme ProImputation peut etre ignoree plusieurs fois (RAR)
							key: `${imputation.identifiantProImputation}-${index}`,
						}))}
					/>
				)}
			</RapportJob>
			{servicesNonHabilites.length > 0 && (
				<RapportJob
					resume={getResumeServicesNonHabilites(servicesNonHabilites)}
					testIdResume="resumeServicesNonHabilites"
					titreDetail="Détail des restes à réaliser repris sur « Aucun service »"
				>
					<List
						bulleted
						items={servicesNonHabilites.map((service) => ({
							content: getLibelleServiceNonHabilite(service),
							// Une ligne peut avoir plusieurs services non habilites
							key: `${service.identifiantImputation}-${service.identifiantSvutCpta}`,
						}))}
					/>
				</RapportJob>
			)}
		</Modal.Content>
		<Modal.Actions>
			<Button
				content="Fermer"
				data-testid="closeRapportButton"
				onClick={onClose}
			/>
		</Modal.Actions>
	</>
);

export default RapportImputationsNonTrouvees;
